import api from './api'

export const documentService = {
  // Upload document
  uploadDocument: async (formData) => {
    const response = await api.post('/documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  // Get my documents
  getMyDocuments: async () => {
    const response = await api.get('/documents/my-documents')
    return response.data
  },

  // Get employee documents by employee ID (Admin/HR only)
  getEmployeeDocuments: async (employeeId) => {
    const response = await api.get(`/documents/employee/${employeeId}`)
    return response.data
  },

  // Delete document
  deleteDocument: async (documentId) => {
    const response = await api.delete(`/documents/${documentId}`)
    return response.data
  }
}
